<!--首页 金额统计图标-->
<template>
    <div ref="dayMoneyEcharts" style="width:95%;height:95%;" class="center" />
</template>

<script>
import { mapState } from "vuex";
var echarts = require("echarts");
export default {
    data() {
        return {
            orderSummaryDatas: null,
            axisData: [],
            moneyData: [],
            powerData: [],
            chart: null,
        };
    },
    watch: {
        dayOrderSummary: {
            handler(val) {
                if (!val) {
                    this.$emit("search");
                    return;
                }
                let data = JSON.parse(JSON.stringify(val));
                this.orderSummaryDatas = data.sort((a, b) => {
                    return a.sum_date < b.sum_date ? -1 : 1;
                });
                this.axisData = [];
                this.moneyData = [];
                this.powerData = [];
                this.dealMonthData(this.orderSummaryDatas);
            },
            deep: true,
        },
    },
    computed: {
        ...mapState(["theme", "dayOrderSummary"]),
    },
    mounted() {
        this.chart = echarts.init(this.$refs.dayMoneyEcharts);
    },
    props: {},
    methods: {
        dataEcharts() {
            this.chart.setOption({
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "cross",
                        crossStyle: {
                            color: "#999",
                        },
                    },
                },
                toolbox: {
                    right: "5%",
                    feature: {
                        magicType: { show: true, type: ["line", "bar"] },
                        // restore: { show: true },
                        saveAsImage: { show: true },
                    },
                },
                legend: {
                    data: ["金额", "电量"],
                },
                dataZoom: [
                    {
                        type: "inside", // 内置于坐标系中
                        startValue: this.axisData.length - 20,
                        xAxisIndex: [0],
                        moveOnMouseMove: true,
                        preventDefaultMouseMove: true,
                    },
                    {
                        type: "slider",
                        show: true,
                        startValue: this.axisData.length - 20,
                        xAxisIndex: [0],
                        backgroundColor: "rgba(155,155,155,0)",
                        borderColor: "#f5f3f6",
                        height: 16,
                    },
                ],
                xAxis: [
                    {
                        type: "category",
                        data: this.axisData,
                        axisLabel: {
                            margin: 34,
                            textStyle: {
                                color: "clack",
                                align: "center",
                                fontSize: "12",
                                verticalAlign: "middle",
                                lineHeight: 20,
                            },
                        },
                        axisTick: {
                            interval: 0,
                            length: 5,
                            //  alignWithLabel: true
                        },
                        axisPointer: {
                            type: "shadow",
                        },
                    },
                ],
                yAxis: [
                    {
                        type: "value",
                        name: "金额",
                        min: 0,
                        // interval: 1500,
                        axisLabel: {
                            formatter: "{value} 元",
                            textStyle: {
                                fontSize: "12",
                                color: "black",
                            },
                        },
                        splitLine: {
                            //去掉坐标轴的水平虚线指示线
                            show: true,
                        },
                    },
                    {
                        type: "value",
                        name: "电量",
                        min: 0,
                        // interval: 1500,
                        axisLabel: {
                            formatter: "{value} kw·h",
                            textStyle: {
                                fontSize: "12",
                                color: "black",
                            },
                        },
                    },
                ],
                series: [
                    {
                        name: "金额",
                        type: "bar",
                        data: this.moneyData,
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" },
                            ],
                        },
                        markLine: {
                            data: [{ type: "average", name: "平均值" }],
                            label: {
                                position: "start",
                            },
                        },
                    },
                    {
                        name: "电量",
                        //  type: "line",
                        type: "bar",
                        yAxisIndex: 1,
                        data: this.powerData,
                        markPoint: {
                            data: [
                                { type: "max", name: "最大值" },
                                { type: "min", name: "最小值" },
                            ],
                        },
                        markLine: {
                            data: [{ type: "average", name: "平均值" }],
                            label: {
                                position: "start",
                            },
                        },
                    },
                ],
            });
        },
        //处理获取到的每个月的数据
        dealMonthData(orderSummary) {
            if (!orderSummary) {
                return;
            }
            for (let i = 0; i < orderSummary.length; i++) {
                let data = JSON.parse(JSON.stringify(orderSummary[i]));
                this.axisData.push(data.sum_date);
                this.moneyData.push(data.money.toFixed(2));
                this.powerData.push(data.power.toFixed(2));
            }
            this.dataEcharts();
        },
    },
};
</script>
<style scoped>
.center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>
